import { toWSDateString } from "@wingspanhq/fe-component-library";
import {
  ComplianceEntityUsTaxStatus,
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";

import { useMutationDownloadPayeeW9 } from "../../../../../../query/payee/mutations/useMutationDownloadPayeeW9";
import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementAction,
  RequirementTableCallback
} from "../../../../types";
import { getRequirementEngagementsTableCellProps } from "../../../../utils";
import { TaxVerificationAdditionalData } from "../../types";
import { getTaxVerificationRequirementName } from "../helpers/getTaxVerificationRequirementName";
import { getTaxVerificationRequirementPayeeStatusCell } from "../helpers/getTaxVerificationRequirementPayeeStatusCell";

export const usePayeeTaxVerificationConfig = (
  _callback: RequirementTableCallback
): CellsConfig<
  PayeeRequirement,
  ContextItem,
  TaxVerificationAdditionalData
> => {
  const [downloadW9] = useMutationDownloadPayeeW9();

  return {
    isActionRequired: () => false,

    requirementName: getTaxVerificationRequirementName,

    nameCell: requirement => ({
      text: getTaxVerificationRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.type!
      }),

    statusCell: getTaxVerificationRequirementPayeeStatusCell,

    toolbarActions: (requirement, context, additionalData) => {
      const actions: RequirementAction[] = [];

      // Domestic (W-9) vs. foreign (W-8BEN) is determined by the authoritative
      // `usTaxStatus` on the payer-owned ComplianceEntity for this payee (batch-
      // fetched in ../../index.tsx). Fail-closed: only an explicit `UsPerson`
      // shows the W-9 download; `ForeignPerson` (W-8BEN), `Undetermined`, an
      // absent entity, or one not yet loaded all keep it hidden.
      // TODO(v3): this covers payer-supplied identities only — payee-owned
      // identities (`identitySource === PayeeOwned`) expose no status to the
      // payer, so they stay fail-closed. Compliance must sign off on W-9/W-8BEN
      // routing before ship.
      const isDomesticPayee =
        additionalData.complianceEntity?.usTaxStatus ===
        ComplianceEntityUsTaxStatus.US_PERSON;

      if (
        // requirement.dataSourceMetadata &&
        isDomesticPayee &&
        requirement.status === RequirementStatus.COMPLETED
      ) {
        actions.push({
          label: "Download PDF",
          icon: "download",
          onClick: () => {
            if (!additionalData.payee?.id) {
              return;
            }

            downloadW9({
              payeeId: additionalData.payee?.id,
              filename:
                additionalData.payee?.email ||
                `${toWSDateString(new Date(), "monthDayYear")}`
            });
          }
        });
      }

      return actions;
    },

    engagementsCell: getRequirementEngagementsTableCellProps
  };
};
